import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}

const Dashboard: React.FC = () => {
  const endpoint = '/programs';
  const title = 'Programação';

  const schema: Record<string, any> = {
    id: { ref: 'id', column: 'id', label: 'ID' },
    date: { ref: 'date', column: 'date', label: 'Data', mask: 'date' },

    start_hour: {
      ref: 'start_hour',
      column: 'start_hour',
      label: 'Hora de início',
      mask: 'hour',
    },
    end_hour: {
      ref: 'end_hour',
      column: 'end_hour',
      label: 'Hora de encerramento',
      mask: 'hour',
    },
    category: { ref: 'category', column: 'category', label: 'Categoria' },
    title: { ref: 'title', column: 'title', label: 'Título' },
    description: {
      ref: 'description',
      column: 'description',
      label: 'Descritivo',
      show: false,
    },
    program_group_id: {
      ref: 'program_group_id',
      column: 'program_group_id_response',
      includeColumn: 'title',
      label: 'Grupo',
      filter: true,
    },

    room_reference_id: {
      ref: 'room_reference_id',
      column: 'room_reference_id_response',
      includeColumn: 'title',
      label: 'Sala',
      filter: true,
    },
    status: {
      ref: 'status',
      column: 'status_response',
      includeColumn: 'title',
      label: 'Status',
      filter: true,
    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    status: {
      alias: 'status',
      model: 'selectApi',
      name: 'status',
      label: 'Status',
      defaultValue: 1,

      endpoint,
    },
    program_group_id: {
      alias: 'program_group_id',
      model: 'selectApi',
      name: 'program_group_id',
      label: 'Grupo',
      defaultValue: 1,

      endpoint,
    },
    room_reference_id: {
      model: 'input',
      type: 'text',
      name: 'room_reference_id',
      label: 'Sala',
    },

    date: { model: 'datePickerHour', type: 'text', name: 'date', label: 'Data' },
    start_hour: {
      model: 'datePickerHour',
      type: 'text',
      name: 'start_hour',
      label: 'Hora de início',
      mask: 'hora',
    },
    end_hour: {
      model: 'datePickerHour',
      type: 'text',
      name: 'end_hour',
      label: 'Hora de Encerramento',
      mask: 'hora',
    },
    category: {
      model: 'input',
      type: 'text',
      name: 'category',
      label: 'Categoria',
    },
    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    description: {
      model: 'richText',
      type: 'text',
      name: 'description',
      label: 'Descritivo',
    },
    video_id: {
      alias: 'video_id',
      model: 'selectApi',
      name: 'video_id',
      label: 'Vídeo de Referência',

      endpoint,
    },
  };

  const formSchemaUpdate = {
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {
    title: {
      name: 'title',
      type: 'string',
      label: 'Título',
      rules: [{ type: 'required' }],
    },
  };

  
  const config: ISearchComponent = {
    idKey: endpoint,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
      lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Dashboard;
